import { useEffect } from 'react';
import 'url-polyfill';
import * as JspUtil from '../common/JspUtil';
import submitHiddenForm from '../common/submitHiddenForm';
import { useJspVariables, useNavigation, useAppContext, useAuth, useDebugRender } from '../hooks';

const PageMemberLogin = () => {
    useDebugRender('PageMemberLogin');
    const { jspVariables } = useJspVariables();
    const { toPageUserInfo } = useNavigation();
    const { getLoginApp } = useAppContext(jspVariables);
    const { isAuthenticated } = useAuth();

    useEffect(() => {
        if (jspVariables.jspPage === 'MEMBER_APPS') {
            toPageUserInfo();
            return;
        }
        if (isAuthenticated) {
            submitHiddenForm('/getMemberLoginApps', {
                loginApp: getLoginApp(),
                secondAuth: JspUtil.isValueAvailable(window.jspSecondAuth) ? window.jspSecondAuth : undefined,
                refererDomain: JspUtil.isValueAvailable(window.jspRefererDomain) ? window.jspRefererDomain : '',
            });
        }
    }, []);

    return null;
};

export default PageMemberLogin;
